import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
// import 'firebase/compat/analytics';



const firebaseConfig = {
    apiKey: "AIzaSyA1wYiD5o9YQCzjuvTJvw7hNq_0943ilWo",
    authDomain: "clone-32b04.firebaseapp.com",
    projectId: "clone-32b04",
    storageBucket: "clone-32b04.appspot.com",
    messagingSenderId: "665354523874",
    appId: "1:665354523874:web:269c8143037934962bbabb",
    measurementId: "G-M70VNWX5P6"
  };

  const fireApp= firebase.initializeApp(firebaseConfig)
  const db =fireApp.firestore()
   export const auth = firebase.auth()
   export default  db